import React from 'react';

class Footer extends React.Component {
    render() {
        return (
            <div className="vg-footer">
                <h1 className="text-center">KEEP SMILING</h1>
            </div>
        )
    }
}

export default Footer;